var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
var Icon = styled.svg(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var isDisabled = _a.isDisabled, isError = _a.isError, theme = _a.theme;
    if (isDisabled) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                polygon {\n                    fill: ", ";\n                }\n            "], ["\n                polygon {\n                    fill: ", ";\n                }\n            "])), theme.colorControlIconDisabled);
    }
    if (isError) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                polygon {\n                    fill: ", ";\n                }\n            "], ["\n                polygon {\n                    fill: ", ";\n                }\n            "])), theme.colorControlIconError);
    }
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            polygon {\n                fill: ", ";\n            }\n        "], ["\n            polygon {\n                fill: ", ";\n            }\n        "])), theme.colorControlIcon);
});
export var ClearIcon = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, rest = __rest(_a, ["disabled", "error"]);
    return (React.createElement(Icon, __assign({}, rest, { viewBox: "0 0 16 16", width: "16px", height: "16px", isDisabled: disabled, isError: error }),
        React.createElement("polygon", { points: "16 1.413 14.587 0 8 6.587 1.413 0 0 1.413 6.587 8 0 14.587 1.413 16 8 9.413 14.587 16 16 14.587 9.413 8 16 1.413" })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ClearIcon.js.map